
















import Select from "@/components/custom/select/Select.vue";
import { debounceProcess } from "@/helpers/debounce";
import { useProductCategory } from "@/hooks";
import { FIRST_PAGE } from "@/mixins/MQueryPage.vue";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ONE } from "@/models/constant/global.constant";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { ProductCategoryResponseDto } from "@/models/interface/product-category";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    Select,
  },
})
export default class SelectProductCategory extends Vue {
  @Prop({ required: true, type: String, default: "" })
  value!: string;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Array<Option<ProductCategoryResponseDto>> = [];
  loading = false;

  pagination = {
    page: FIRST_PAGE,
    search: "",
  };

  allLoaded = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions(this.buildParams());
  }

  fetchOptions(params: RequestQueryParamsModel): void {
    const { findAll, toOptions } = useProductCategory();
    this.loading = true;
    findAll(params)
      .then(({ data, currentPage, totalPages }) => {
        this.allLoaded = currentPage + ONE === totalPages;
        const copy = [...this.options];
        this.options = [...copy, ...toOptions(data)];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { searchBy } = useProductCategory();
    this.resetState();
    const params = new RequestQueryParams();
    params.search = searchBy({ name: val });

    this.fetchOptions(params);
  }

  findOption(value: string): Option<ProductCategoryResponseDto> | undefined {
    return this.options.find(e => value === e.value);
  }

  buildParams(): RequestQueryParamsModel {
    const params = new RequestQueryParams();
    const { page, search } = this.pagination;
    params.page = page - ONE;
    params.search = search;
    return params;
  }

  onScrollEnd(): void {
    if (this.loading || this.allLoaded) return;
    this.pagination.page += ONE;
    this.fetchOptions(this.buildParams());
  }

  resetState(): void {
    this.pagination.page = ONE;
    this.options = [];
    this.allLoaded = false;
  }
}
